import React, { useState } from 'react';
import Button from '../button';
import './styles.scss';

function ConfirmDialog({ isShowConfirmDialog,message, onConfirm, onCancel, data}) {
   
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm(data);
        }
    };
    const handleCancel = () => {
        if (onCancel) {
            onCancel(data);
        }
    };
    return (
        <div>
            <div className="messagedialog" style={{ display: isShowConfirmDialog ? 'flex' : 'none' }}>
                <div className="messagedialogModel">
                    <div className="dialogTitle">提示</div>
                    <div className="dialog-content">
                        <div className="dialogContent">{message}</div>
                        <div className="btn-div">
                            <Button btnclass="nomal_btn " onClick={handleConfirm} title="确定" ></Button>
                            <Button btnclass="nomal_btn " onClick={handleCancel} title="取消" >取消</Button>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;